var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsultant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.144 102.359L65.4335 106.938C63.0175 111.02 56.9825 111.02 54.5665 106.938L51.856 102.359C49.7536 98.807 48.7024 97.0315 47.0139 96.049C45.3254 95.067 43.1996 95.0305 38.9479 94.9575C32.6711 94.849 28.7344 94.4645 25.4329 93.097C19.3072 90.5595 14.4403 85.693 11.903 79.567C10 74.973 10 69.1485 10 57.5V52.5C10 36.1328 10 27.9492 13.684 21.9375C15.7454 18.5736 18.5736 15.7454 21.9375 13.684C27.9492 10 36.1328 10 52.5 10H67.5C83.867 10 92.0505 10 98.0625 13.684C101.426 15.7454 104.254 18.5736 106.316 21.9375C110 27.9492 110 36.1328 110 52.5V57.5C110 69.1485 110 74.973 108.097 79.567C105.559 85.693 100.693 90.5595 94.567 93.097C91.2655 94.4645 87.329 94.849 81.052 94.9575C76.8 95.0305 74.6745 95.067 72.986 96.049C71.2975 97.031 70.246 98.807 68.144 102.359Z",
    fill: "#A5647C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 45C36.25 42.929 37.929 41.25 40 41.25H80C82.071 41.25 83.75 42.929 83.75 45C83.75 47.0711 82.071 48.75 80 48.75H40C37.929 48.75 36.25 47.0711 36.25 45Z",
    fill: "#A5647C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 62.5C36.25 60.429 37.929 58.75 40 58.75H67.5C69.571 58.75 71.25 60.429 71.25 62.5C71.25 64.571 69.571 66.25 67.5 66.25H40C37.929 66.25 36.25 64.571 36.25 62.5Z",
    fill: "#A5647C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultant);
export default __webpack_public_path__ + "static/media/consultant.2dcb2bd0cccd722e16e556f6f6d48a42.svg";
export { ForwardRef as ReactComponent };